import { useAdFleetMapVehicles } from '@backoffice-frontend/ad-fleet-map'
import { useWorkspaceOperatorRole } from '@backoffice-frontend/ad-workspace'
import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'
import { getHandlingOperatorForRole } from './AdAlertFeedCard/utils'

/**
 * The source of truth for "handling an alert", which drives disabling the
 * on/off-duty toggle.
 */
export const useIsHandlingAlert = (): boolean => {
  const { vehicles } = useAdFleetMapVehicles()
  const role = useWorkspaceOperatorRole()
  const { user } = useBackofficeLoggedInUser()

  if (!user?.id) return false

  return vehicles.some(
    vehicle => getHandlingOperatorForRole(vehicle, role)?.id === user.id,
  )
}
